module.exports = __webpack_public_path__ + "img/ETC.148fd866.svg";